import { MultiPin } from "@mapmycustomers/shared/types/map";
import anyColorToHex from "@mapmycustomers/shared/util/color/anyColorToHex";
import getContrastColor from "@mapmycustomers/shared/util/color/getContrastColor";

import colors from "@app/styles/_colors.module.scss";
import ColorDefinition from "@app/util/map/markerStyles/types/ColorDefinition";

const defaultColorGetter = (multiPin: MultiPin): ColorDefinition => {
  const fillColor = multiPin.data.color ? anyColorToHex(multiPin.data.color) : colors.slate;
  return {
    color: getContrastColor(fillColor) === "black" ? colors.slate : colors.white,
    fillColor,
  };
};

export default defaultColorGetter;
